/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EventGroupsListComponent } from './events-groups/event-groups-list/event-groups-list.component';
import { EventGroupsFormComponent } from './events-groups/event-groups-form/event-groups-form.component';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '@app/shared';
import { EventsRoutingModule } from '@app/events/events-routing.module';
import { EventsListComponent } from './events/events-list/events-list.component';
import { EventsFormComponent } from './events/events-form/events-form.component';
import { EventGroupsSeoFormComponent } from './events-groups/event-groups-seo-form/event-group-seo-form.component';
import { EventsSeoFormComponent } from './events/events-seo-form/events-seo-form.component';
import { EventGroupsViewComponent } from './events-groups/event-groups-view/event-groups-view.component';
import { EventsViewComponent } from './events/events-view/events-view.component';

@NgModule({
  declarations: [
    EventGroupsListComponent,
    EventGroupsFormComponent,
    EventsFormComponent,
    EventsListComponent,
    EventsFormComponent,
    EventGroupsSeoFormComponent,
    EventsSeoFormComponent,
    EventGroupsViewComponent,
    EventsViewComponent,
  ],
  imports: [CommonModule, EventsRoutingModule, ReactiveFormsModule, SharedModule],
})
export class EventsModule {}
